// extracted by mini-css-extract-plugin
export default {"weekList":"UpcomingDaysForecast_weekList__Va9C9"};